import * as Yup from 'yup';

import { LANGUAGE_CODE } from '@/enums/LanguageCodeEnum';
import { getLanguageOptionsForServiceMessage } from '@/helpers/LanguageHelper';
import i18n from '@/i18n';

export const createEditServiceMessageSchema = Yup.object().shape({
  backgroundColor: Yup.string().required(() => i18n.t('backgroundColorRequired', { ns: 'common' })),
  values: Yup.object(
    getLanguageOptionsForServiceMessage().reduce(
      (acc, { code }) => {
        let requiredKey = '';
        switch (code) {
          case LANGUAGE_CODE[LANGUAGE_CODE.EnglishUS]:
            requiredKey = 'messageEnRequired';
            break;
          case LANGUAGE_CODE[LANGUAGE_CODE.FrenchFR]:
            requiredKey = 'messageFrRequired';
            break;
          case LANGUAGE_CODE[LANGUAGE_CODE.DutchBE]:
            requiredKey = 'messageNlRequired';
            break;
          case LANGUAGE_CODE[LANGUAGE_CODE.GermanDE]:
            requiredKey = 'messageDeRequired';
            break;
          default:
            requiredKey = 'messageEnRequired';
        }

        acc[code] = Yup.string().required(() => i18n.t(requiredKey, { ns: 'common' }));
        return acc;
      },
      {} as Record<string, Yup.StringSchema>
    )
  )
});
